import { AppBar, Box, Grid, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Outlet, useNavigate } from 'react-router-dom';
// media query
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Background from '../assets/mainbg.jpg'
export const Dashboard = () => {
    // media query
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const [name,setName] = useState('')
    const [office,setOffice] = useState('')
    const userType = localStorage.getItem('user_type');

    useEffect(()=>{
        let n = localStorage.getItem('name');
        let o = localStorage.getItem('office');
        setName(n)
        setOffice(o)
    },[])
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {
        console.log('here')
        localStorage.setItem('name','');
        localStorage.setItem('office','');
        localStorage.setItem('user_id','');
        localStorage.setItem('user_type','');
        // navigate('/');
        window.location.href = '/'
    }
    return (
        <Box>
            <Box>
                {/* {
                    matches
                    ?
                    null
                    :
                    null
                } */}
                <img src={Background} height={matches?'120%':'100%'} width='100%' style={{position:'absolute',zIndex:-1,top:0,opacity:'.2'}}/>
            </Box> 
            <AppBar>
                <Toolbar sx={{display:'flex',justifyContent:'space-between'}}>
                    <Typography>{name} ({office})</Typography>
                    <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Box sx={{ py: 1, marginTop: matches ? '64px' : '66px' }}>
                <Outlet />
            </Box>
        </Box>

    )
}
